/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

export type SourceReputationUpdatedEvent = {
  agent: Address;
  sourceName: string;
  sourceScore: number;
  weightedAggregateScore: bigint;
  hasConflict: boolean;
  totalSources: number;
  timestamp: bigint;
};

export type SourceReputationUpdatedEventArgs = {
  agent: Address;
  sourceName: string;
  sourceScore: number;
  weightedAggregateScore: number | bigint;
  hasConflict: boolean;
  totalSources: number;
  timestamp: number | bigint;
};

export function getSourceReputationUpdatedEventEncoder(): Encoder<SourceReputationUpdatedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["sourceName", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["sourceScore", getU16Encoder()],
    ["weightedAggregateScore", getU64Encoder()],
    ["hasConflict", getBooleanEncoder()],
    ["totalSources", getU32Encoder()],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getSourceReputationUpdatedEventDecoder(): Decoder<SourceReputationUpdatedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["sourceName", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["sourceScore", getU16Decoder()],
    ["weightedAggregateScore", getU64Decoder()],
    ["hasConflict", getBooleanDecoder()],
    ["totalSources", getU32Decoder()],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getSourceReputationUpdatedEventCodec(): Codec<
  SourceReputationUpdatedEventArgs,
  SourceReputationUpdatedEvent
> {
  return combineCodec(
    getSourceReputationUpdatedEventEncoder(),
    getSourceReputationUpdatedEventDecoder(),
  );
}
